import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { IS_LAUNCHER } from '../utils/launcher'
import { useAuthContext } from '../context/auth'

const RequireRoles = ({ Roles }) => {
    const { auth } = useAuthContext()
    const { pathname } = useLocation()
    // Desktop launcher: chat only, whatever the role
    if (IS_LAUNCHER && pathname !== '/chat') return <Navigate to="/chat" replace />
    const checkRoles = auth.roles.find(role => Roles.includes(role))
    return (checkRoles && auth ? <Outlet /> : <Navigate to="/" />) 
}

export default RequireRoles 